import { useEffect, useState } from "react";
import { auth } from "./utils/FireStore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getCurrentUserSubscriptions, getStripePayments } from '@invertase/firestore-stripe-payments';
import { getApp } from 'firebase/app';
import { getUserCompanyId } from "./utils/api/user"
import { getCompanyById } from "./utils/api/company"

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
    const [userCompanyId, setUserCompanyId] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);

        // Check subscription status
        try {
          setIsCheckingSubscription(true);
          const payments = getStripePayments(getApp(), {
            customersCollection: 'customers',
            productsCollection: 'subscriptions', // Your products are stored in 'subscriptions' collection
          });

          const subs = await getCurrentUserSubscriptions(payments, { status: 'active' });
          const hasActiveSubscription = subs.length > 0;

          if (!hasActiveSubscription) {
            // not yet subscribed — send them to your subscribe page
            navigate("/subscribe-now");
            return;
          }
        } catch (error) {
          console.error("Error checking subscription:", error);
          // On error, assume not subscribed and redirect
          navigate("/subscribe-now");
          return;
        } finally {
          setIsCheckingSubscription(false);
        }


        getUserCompanyId()
          .then((id) => {
            if (!id) {
              navigate("/create-company");
              return;
            }
            getCompanyById(id)
              .then((company) => {
                setUserCompanyId(id);
                setCompanyData(company);
              })
              .catch((err) => {
                console.log("Error getting and setting company data: ", err);
              });
          })
          .catch((err) => {
            console.log(
              "Error getting user company id, forwarding to /create-company ",
              err
            );
            navigate("/create-company");
          });
      } else {
        navigate("/sign-in");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (!user || isCheckingSubscription) {
    return null; // or a loading spinner
  }

  return children;
};

export default ProtectedRoute;
